import Alpine from 'alpinejs';
import { sendEvent } from "./sendEvent";

export function initAlpineUtils() {
  Alpine.magic('sendEvent', () => {
    return (eventName, eventDetails = {}) => {
      sendEvent(eventName, eventDetails);
    };
  });
}